// extracted by mini-css-extract-plugin
export var contentColumn = "BrindusaHero-module--contentColumn--38ff6";
export var contentContainer = "BrindusaHero-module--contentContainer--a4066";
export var imageContainer = "BrindusaHero-module--imageContainer--26a60";
export var renderContent = "BrindusaHero-module--renderContent--71d0e";
export var sectionContainer = "BrindusaHero-module--sectionContainer--0dbee";
export var sectionContentContainer = "BrindusaHero-module--sectionContentContainer--533c3";